import React from "react";
import { Link } from 'react-router-dom';
import paths from '../../routes/paths';
import { titleCodes, imageCodes, videoCodes, textCodes } from "../../template_codes/29/membership_page_codes";

function Membership() {
    return (
        <div>

            <div className="container w-4/5 py-20">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-8">
                    <div className="px-2">
                        <p className='tracking-wider leading-loose text-justify'>{textCodes.joinOur.text}</p>
                        <h1 className="text-3xl font-semibold xl:pb-8 pb-4">{titleCodes.loyaltyTitle.title}</h1>
                        <p className='font-semibold leading-loose text-justify'>{textCodes.earnPointsMember.text}</p>
                        <p className='tracking-wider leading-loose text-justify'>{textCodes.loyaltyDes1.text}</p>
                        <p className='tracking-wider leading-loose text-justify'>{textCodes.loyaltyDes2.text}</p>
                        <div className="flext justify-between grid grid-cols-2 md:grid-cols-2 lg:grid-cosl-2 xl:grid-cols-2 2xl:grid-cols-2 pt-8">
                            <a href="https://apps.apple.com/us/app/29-jewellery/id6443877935"><img src={imageCodes.appStore.image} alt="appstore" width={180} height={140}></img></a>
                            <a href="https://play.google.com/store/apps/details?id=twoninejewellery.piti.member&hl=en&gl=US"><img src={imageCodes.googlePlay.image} alt="google playstore" width={180} height={140}></img></a>
                        </div>
                    </div>
                    <div>
                        <embed src={videoCodes.memberVideo.video} title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
                            className="w-full h-64 md:h-80 lg:h-80 xl:h-96 2xl:h-96">
                        </embed>
                    </div>
                </div>
            </div>

            <div className="mx-auto px-4">
                <div className="md:text-center lg:text-center xl:text-center 2xl:text-center">
                    <p className="mt-10 text-3xl font-bold leading-8 tracking-tight text-gray-900">
                        {titleCodes.rewardTitle.title}
                    </p>
                    <h2 className="tracking-wider leading-loose py-2 text-xl mt-4 max-w-2xl md:mx-auto lg:mx-auto xl:mx-auto 2xl:mx-auto">
                        {textCodes.rewardDes.text}
                    </h2>
                    <p className='pb-8 leading-loose text-center text-gray-500'>{textCodes.expire.text}</p>
                </div>
            </div>

            <div className="px-2 md:px-8 lg:px-10 xl:px-10 2xl:px-10 grid grid-cols-2 md:grid-cols-3 lg:gird-cols-5 xl:grid-cols-5 2xl:grid-cols-5 gap-4">
                <div class="flex items-center space-x-4">
                    <img src={imageCodes.reward3.image} alt="Location Icon" width="80" height="90" class="rounded-lg flex-none" loading="lazy" />
                    <div class="min-w-0 flex-auto space-y-1 font-semibold">
                        <p class="text-gray-700 dark:text-cyan-900 font-semibold leading-6">
                            {textCodes.rewardText1.text}
                        </p>
                        <p className='text-gray-500'>{textCodes.rewardPoint1.text}</p>
                    </div>
                </div>
                <div class="flex items-center space-x-4">
                    <img src={imageCodes.reward2.image} alt="Location Icon" width="80" height="90" class="flex-none rounded-lg" loading="lazy" />
                    <div class="min-w-0 flex-auto space-y-1 font-semibold">
                        <p class="text-gray-700 dark:text-cyan-900 font-semibold leading-6">
                            {textCodes.rewardText2.text}
                        </p>
                        <p className='leading-loose text-gray-500'>{textCodes.rewardPoint2.text}</p>
                    </div>
                </div>
                <div class="flex items-center space-x-4">
                    <img src={imageCodes.reward1.image} alt="Location Icon" width="80" height="90" class="flex-none rounded-lg" loading="lazy" />
                    <div class="min-w-0 flex-auto space-y-1 font-semibold">
                        <p class="text-gray-700 dark:text-cyan-900 font-semibold leading-6">
                            {textCodes.rewardText3.text}
                        </p>
                        <p className='leading-loose text-gray-500'>{textCodes.rewardPoint3.text}</p>
                    </div>
                </div>
                <div class="flex items-center space-x-4">
                    <img src={imageCodes.reward2.image} alt="Location Icon" width="80" height="90" class="flex-none rounded-lg" loading="lazy" />
                    <div class="min-w-0 flex-auto space-y-1 font-semibold">
                        <p class="text-gray-700 dark:text-cyan-900 font-semibold leading-6">
                            {textCodes.rewardText4.text}
                        </p>
                        <p className='leading-loose text-gray-500'>{textCodes.rewardPoint4.text}</p>
                    </div>
                </div>
                <div class="flex items-center space-x-4">
                    <img src={imageCodes.reward1.image} alt="Location Icon" width="80" height="90" class="flex-none rounded-lg" loading="lazy" />
                    <div class="min-w-0 flex-auto space-y-1 font-semibold">
                        <p class="text-gray-700 dark:text-cyan-900 font-semibold leading-6">
                            {textCodes.rewardText5.text}
                        </p>
                        <p className='leading-loose text-gray-500'>{textCodes.rewardPoint5.text}</p>
                    </div>
                </div>
                <div class="flex items-center space-x-4">
                    <img src={imageCodes.reward3.image} alt="Location Icon" width="80" height="90" class="flex-none rounded-lg" loading="lazy" />
                    <div class="min-w-0 flex-auto space-y-1 font-semibold">
                        <p class="text-gray-700 dark:text-cyan-900 font-semibold leading-6">
                            {textCodes.rewardText1.text}
                        </p>
                        <p className='leading-loose text-gray-500'>{textCodes.rewardPoint1.text}</p>
                    </div>
                </div>
            </div>

            <div className="my-16">
                <p className="py-16 text-3xl font-bold leading-8 tracking-tight text-center text-gray-900">
                    29 Jewellery Digital Membership
                </p>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-0 xl:pl-16 2xl:pl-20">
                    <div class="carousel-item p-4">
                        <div class="card w-96 bg-base-100 shadow-xl">
                            <figure><img src={imageCodes.loyalty1.image} alt="Shoes" /></figure>
                            <div class="card-body">
                                <a href="https://willowlabelmm.com/">
                                    <h2 class="card-title pb-4">
                                        {textCodes.memberCard.text}
                                    </h2>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item p-4">
                        <div class="card w-96 bg-base-100 shadow-xl">
                            <figure><img src={imageCodes.loyalty2.image} alt="Shoes" /></figure>
                            <div class="card-body">
                                <a href="https://willowlabelmm.com/">
                                    <h2 class="card-title pb-4">
                                        {textCodes.pointSystem.text}
                                    </h2>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="carousel-item p-4">
                        <div class="card w-96 bg-base-100 shadow-xl">
                            <figure><img src={imageCodes.loyalty3.image} alt="Shoes" /></figure>
                            <div class="card-body">
                                <a href="https://willowlabelmm.com/">
                                    <h2 class="card-title pb-4">
                                        {textCodes.memberShop.text}
                                    </h2>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );
}

export default Membership;